import { axiosClient } from "@/lib/axiosClient";

export interface FeedbackPayload {
    name?: string;
    email?: string;
    institution?: string;
    message: string;
}

export interface FeedbackSubmitResult {
    status: string;
    message: string;
    data: { id: number };
}

export const submitFeedback = async (payload: FeedbackPayload) => {
    const { data } = await axiosClient.post<FeedbackSubmitResult>("/public/feedback", payload);
    return data;
};
